import homeView from './home';
import programView from './program';
import campusView from './campus';
import newsletterView from './newsletter';
import visitView from './visit';
import eventView from './event';
import privateHireView from './privateHire';
import joinView from './join';
import spaceView from './space';
import serieView from './serie';

export default [homeView, programView, campusView, visitView, eventView, privateHireView, joinView, spaceView, newsletterView, serieView];
